import { FC } from 'react'
import PerFlexRow from '../../FlexRow'
import PerText from '../../Text'
import PerInputNumber from '../../PerInputNumber'

import '../index.less'

type Props = {
  label: string
  min: number
  max: number
  value?: number
  onChange: (value?: number) => void
  type?: 'currency' | 'percentage' | 'decimalPercentage'
  width?: string
  step?: number
  disabled?: boolean
}

export const PerInfoBoxInputNumberElement: FC<Props> = ({ label, type, min, max, value, onChange, width, step, disabled }) => {
  return (
    <PerFlexRow align="middle" justify="center" direction="column" className="per-infoBox--tagElement">
      <PerText appearance="label-small" align="center" mb="s">
        {label}
      </PerText>
      <PerInputNumber
        type={type}
        min={min}
        max={max}
        value={value}
        onChange={onChange}
        size="small"
        step={step}
        width={width}
        disabled={disabled}
      />
    </PerFlexRow>
  )
}
